"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import e from "../components/Icon/SvgIcon.js";
const m = (l) => /* @__PURE__ */ o(
  e,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M7.614 8.345v1.587h6.315V8.345zm12.37 12.352-4.492-6.139c1.557-1.31 2.55-3.251 2.55-5.42C18.041 5.203 14.78 2 10.771 2S3.5 5.203 3.5 9.137c0 3.938 3.263 7.14 7.271 7.14a7.3 7.3 0 0 0 3.106-.695l4.546 6.214c.154.211.444.268.646.126l.827-.583a.453.453 0 0 0 .088-.642m-9.213-6.125c-3.053 0-5.535-2.438-5.535-5.435 0-2.995 2.482-5.432 5.535-5.432 3.051 0 5.536 2.437 5.536 5.432 0 2.997-2.484 5.435-5.536 5.435",
        clipRule: "evenodd"
      }
    )
  }
), n = t(m);
export {
  n as ZoomOut,
  n as default
};
